module.exports = __webpack_public_path__ + "components/app-promo/static/de/snow-forecast__app-screenshot--4-794f11cb691f5f28f3ce3a58dbfb66cd.jpg";